export default __webpack_public_path__ + "static/media/move_CONTAINER_to_DESTINATION.0cfe482e.svg";